import { render, staticRenderFns } from "./Kuesioner.vue?vue&type=template&id=35c14b3c&scoped=true"
import script from "./Kuesioner.vue?vue&type=script&lang=js"
export * from "./Kuesioner.vue?vue&type=script&lang=js"
import style0 from "./Kuesioner.vue?vue&type=style&index=0&id=35c14b3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c14b3c",
  null
  
)

export default component.exports